import React, { useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import { addRestaurant } from '../hooks/resturant'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addMainMeals } from '../hooks/MainMeals'

function AddMainMeals() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const { list } = useSelector((state) => state.resturants);
      const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        {
          id: "parent_id",
          title: "اختار الوجبة الاساسية",
          type: "select",
          options:[{id:10,name:"الافطار"},{id:11,name:"الغداء"},{id:12,name:"العشاء"}],
        },    {
          id: "restaurant_ids",
          title: "اختار المطعم",
          type: "select",
          options:list,
        },
                { id: "name", title: "اسم الوجبة", type: "text", },
                { id: "image", title: "صورة الوجبة", type: "file" },
                { id: "description", title: "وصف الوجبة", type: "textarea", },

            ],
    },
  ];
  const handleSubmit = (formData) => {
  const data = {
    ...formData,
    restaurant_ids: [Number(formData.restaurant_ids)], // 🔥 الحل هنا
  };
  // console.log(data);
  
  // const dataformData = new FormData();

  // Object.keys(formData).forEach((key) => {
  //   dataformData.append(key, formData[key]);
  // });
  // console.log(dataformData);

    dispatch(addMainMeals(data))
      .unwrap() // Allows us to use .then() / .catch() on the thunk result
      .then(() => {
        alert("تم إضافة الوجبة بنجاح");
        navigate('/dashboard/main-meals'); // Redirect to list page
      })
      .catch((err) => {
        // Error is already handled in Redux, but you can do specific UI logic here
        console.error("Failed to save:", err);
      });
  };
  return (
    <div>
        <AuthNavbar/>
          <Container>
                    <CustomHeader
          title={"إضافة وجبة جديد"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
formStructure={infoData}
image={false}
onSubmit={handleSubmit}
        />
            </Container>
            </div>
  )
}

export default AddMainMeals
